export default "__VITE_ASSET__CQcZYefa__"